var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.56764 18.6526H19.13C19.618 18.6526 20 18.2526 20 17.7895V2.86316C20 2.37895 19.5968 2 19.13 2H4.87003C4.38196 2 4 2.4 4 2.86316V19.4526C4 20.8632 5.14589 22 6.56764 22H19.13C19.618 22 20 21.6 20 21.1368C20 20.6526 19.5968 20.2737 19.13 20.2737H6.56764C6.12202 20.2737 5.76127 19.9158 5.76127 19.4737C5.76127 19.0105 6.12202 18.6526 6.56764 18.6526ZM5.76127 3.74737H18.2599V16.9053H6.56764C6.29178 16.9053 6.01592 16.9474 5.76127 17.0316V3.74737Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47508 8.84209H10.1753C10.43 8.84209 10.6422 8.67367 10.6846 8.42104C10.7695 7.93683 11.0666 7.34735 12.0427 7.34735C12.7854 7.34735 13.0825 7.7263 13.2098 7.95788C13.3796 8.29472 13.3584 8.67367 13.1462 8.96841C12.934 9.26314 12.7218 9.41051 12.4883 9.57893C11.8942 9.99999 11.3849 10.4421 11.3 11.6842C11.2788 11.8316 11.3425 11.9579 11.4273 12.0631C11.5334 12.1684 11.6608 12.2316 11.8093 12.2316H12.5096C12.7854 12.2316 12.9976 12.021 13.0188 11.7684C13.0613 11.2842 13.1674 11.2 13.4857 10.9895C13.7615 10.8 14.1647 10.5263 14.5467 9.99999C15.1409 9.19999 15.2257 8.1263 14.7589 7.19999C14.2708 6.23156 13.2523 5.64209 12.0639 5.64209C10.0905 5.64209 9.178 7.05262 9.00823 8.27367C8.98701 8.42104 9.02945 8.56841 9.13556 8.67367C9.178 8.77893 9.32654 8.84209 9.47508 8.84209Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1277 15.0104C12.7019 15.0104 13.1675 14.5486 13.1675 13.9788C13.1675 13.4091 12.7019 12.9473 12.1277 12.9473C11.5534 12.9473 11.0879 13.4091 11.0879 13.9788C11.0879 14.5486 11.5534 15.0104 12.1277 15.0104Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipIcon);
export default __webpack_public_path__ + "static/media/tip_icon.e4f42c2b317f97ab434f62e0e1841f5e.svg";
export { ForwardRef as ReactComponent };